import React from 'react';
import { ExplicitSourcesChip } from './ExplicitSourcesChip';
import {
    ControlledSourcesChip,
    type ControlledSourcesPopover,
    type ControlledSourcesSelection,
} from './ControlledSourcesChip';

interface SourcesFilterChipProps {
    /** Explicit source IDs — when provided, bypasses the global sources store
     *  and renders the AlertRule-style chips (with X to remove). */
    sourceIds?: string[];
    onRemoveSource?: (id: string) => void;
    /** Controlled selection state — required when `sourceIds` is not provided. */
    selection?: ControlledSourcesSelection;
    /** Externally-controlled popover used by the controlled chip variant. */
    popover?: ControlledSourcesPopover;
    /** Label shown when the controlled selection is empty (e.g. "0 sources"). */
    emptyLabel?: string;
    invalidHighlight?: boolean;
    tagVariant?: 'base' | 'plain';
}

export function SourcesFilterChip({
    sourceIds,
    onRemoveSource,
    selection,
    popover,
    emptyLabel,
    invalidHighlight,
    tagVariant,
}: SourcesFilterChipProps) {
    if (sourceIds !== undefined) {
        return (
            <ExplicitSourcesChip
                sourceIds={sourceIds}
                onRemoveSource={onRemoveSource}
                tagVariant={tagVariant}
            />
        );
    }

    if (!selection || !popover) {
        return null;
    }

    return (
        <ControlledSourcesChip
            popover={popover}
            selection={selection}
            emptyLabel={emptyLabel}
            invalidHighlight={invalidHighlight}
            tagVariant={tagVariant}
        />
    );
}
